import { render, staticRenderFns } from "./clientDealerInfo.vue?vue&type=template&id=20051520&scoped=true"
import script from "./clientDealerInfo.vue?vue&type=script&lang=js"
export * from "./clientDealerInfo.vue?vue&type=script&lang=js"
import style0 from "./clientDealerInfo.vue?vue&type=style&index=0&id=20051520&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20051520",
  null
  
)

export default component.exports